
import { defineComponent } from "vue";

export default defineComponent({
  name: "FilterType",
  computed: {
    statuses() {
      return [
        this.$t("search.type_all"),
        this.$t("search.status_open"),
        this.$t("search.status_closed"),
      ]
    },
    status: {
      get() {
        return this.$store.getters.filters.status;
      },
      set(value: string | null) {
        if (value === this.$t("search.type_all")) {
          this.$store.dispatch('updateFilter', { key: 'status', value: null });
        } else {
          let statusFilter = ''
          switch (value) {
            case this.$t("search.status_open"):
              statusFilter = 'open'
              break
            case this.$t("search.status_closed"):
              statusFilter = 'closed'
              break
          }
          this.$store.dispatch('updateFilter', { key: 'status', value: statusFilter });
        }
      },
    },
    statusTranslator() {
      return {
        'open': this.$t("search.status_open"),
        'closed': this.$t("search.status_closed"),
      }
    },
    checked() {
      return (statusOption: string) => {
        return this.status ? this.statusTranslator[this.status as keyof typeof this.statusTranslator] === statusOption : statusOption === this.$t('search.type_all');
      }
    }
  },
  methods: {
    setStatus(event: Event) {
      const target = event.target as HTMLInputElement;
      this.status = target.value;
    },
  },
});
